import type { ReactNode } from "react";

interface AdminModalProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}

/** Reusable centred dialog used by every admin manager. */
export default function AdminModal({
  title,
  subtitle,
  onClose,
  children,
  footer,
  wide = false,
}: AdminModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/50 p-4"
      onClick={onClose}
    >
      <div
        className={`flex max-h-[90vh] w-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 ${
          wide ? "max-w-2xl" : "max-w-lg"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between border-b border-background-200 px-6 py-4">
          <div>
            <h2 className="font-heading text-base font-bold text-foreground-950">{title}</h2>
            {subtitle && <p className="mt-0.5 text-xs text-foreground-500">{subtitle}</p>}
          </div>
          <button type="button" onClick={onClose} className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900">
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-5">{children}</div>

        {footer && (
          <div className="border-t border-background-200 px-6 py-4">{footer}</div>
        )}
      </div>
    </div>
  );
}